import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-payment-has-been-saved',
  templateUrl: './payment-has-been-saved.component.html',
  styleUrls: ['./payment-has-been-saved.component.less'],
  standalone: false
})
export class PaymentHasBeenSavedComponent {
  constructor(private modal: NzModalRef) {}

  done(): void {
    this.modal.destroy();
  }
}
